import { tv } from 'tailwind-variants';

/** Shell page title — Spec §5.7 h3 role (`EnterprisePageHeader` only). */
export const shellPageTitle = tv({
  // FIX 7: compact H1 25px / 700 / ~1.15; md+ keep h3 tokens. Wrap/ellipsis owned by header className.
  base: [
    'm-0 min-w-0 tracking-tight text-[var(--color-an-text)]',
    'text-[25px] font-bold leading-[1.15]',
    'md:text-[length:var(--font-size-h3)] md:leading-[var(--line-height-h3)]',
  ].join(' '),
});

/** In-content panel / section titles — Spec §5.7 h5 role. */
export const panelTitle = tv({
  base: 'm-0 text-[length:var(--font-size-h5)] font-semibold leading-[var(--line-height-h5)] tracking-tight text-[var(--color-an-text)]',
});

/** Lead copy under shell title or panel title — Spec §5.7 small role. */
export const panelLead = tv({
  base: 'm-0 text-[length:var(--font-size-small)] leading-[var(--line-height-small)] text-[var(--color-an-text-muted)]',
});

/** Flex row for contextual actions below the shell header. */
export const screenToolbarRow = tv({
  base: 'flex flex-wrap items-center justify-between gap-3',
});
